import { useCallback } from 'react';

import { MainStoreUserEnvironmentState } from 'modules/main/store/ducks/userEnvironment';
import { fetchUserEnvironment } from 'modules/main/store/ducks/userEnvironment.actions';

import { useMainDispatch } from './useMainDispatch';
import { useMainSelector } from './useMainSelector';

export function useUserEnvironment(): MainStoreUserEnvironmentState & {
  reloadUserEnvironment: () => void;
} {
  const dispatch = useMainDispatch();
  const reloadUserEnvironment = useCallback(() => {
    dispatch(fetchUserEnvironment());
  }, [dispatch]);

  const userEnvironment = useMainSelector((state) => state.userEnvironment);

  return { ...userEnvironment, reloadUserEnvironment };
}
